"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoapMessages = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const AuthoredEvidence = __importStar(require("../../../../../composite/evidence/authored-evidence/authored-evidence"));
const evidence_1 = require("../../../../../composite/evidence/evidence");
const admin_context_1 = require("../../../../../providers/admin/admin-context");
const empty_component_1 = require("../../../../../utils/empty-component");
const messages_columns_1 = require("./messages-columns");
const messages_fields_1 = require("./messages-fields");
function SoapMessages() {
    const intl = (0, react_intl_1.useIntl)();
    const { soapMessagesUrl } = (0, react_1.useContext)(admin_context_1.AdminContext);
    const evidence = AuthoredEvidence.useAuthoredEvidence({
        version: 4,
        identifier: 'SOAP_MESSAGES',
        apiProps: {
            url: soapMessagesUrl,
        },
        tableProps: {
            columns: (0, messages_columns_1.useColumns)(),
            tableName: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_TABLE_TITLE',
                defaultMessage: 'SOAP komunikace',
            }),
        },
        detailProps: {
            GeneralFieldsComponent: empty_component_1.EmptyComponent,
            FieldsComponent: messages_fields_1.MessagesFields,
            toolbarProps: {
                showBtn: lodash_1.stubFalse,
                title: intl.formatMessage({
                    id: 'EAS_SOAP_LOGGER_MESSAGES_DETAIL_TITLE',
                    defaultMessage: 'SOAP komunikace',
                }),
            },
        },
    });
    return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
}
exports.SoapMessages = SoapMessages;
//# sourceMappingURL=messages.js.map